import { memo } from "react";
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import {
    OnboardingApplicationStep,
    OnboardingApplication,
    ECommerceOnboardingApplication,
    onboardingApplicationStepAndFieldStatus
} from "consts/onboarding";
import {
    StepLabel,
    useApplicationDetailContext,
    type StepLabelProps
} from "ui/organizms/Onboarding/Applications/common";

const UBOIdentityVerificationLabel = (props: Partial<StepLabelProps>) => {
    const { getStepData } = useApplicationDetailContext();

    const data = getStepData(ECommerceOnboardingApplication.IdentityVerification);

    return (
        <StepLabel
            to={`${OnboardingApplicationStep[OnboardingApplication.ECommerce].UBOIdentityVerification}`}
            Icon={PermIdentityIcon}
            {...onboardingApplicationStepAndFieldStatus.get(data.status)}
            {...props}
        >
            UBO Identity Verification
        </StepLabel>
    );
};

export default memo(UBOIdentityVerificationLabel);
